import * as React from "react";

const ChevronDown: React.FC = () => {
    return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M13.86 6.484l-.72-.72L8 10.907l-5.14-5.14-.72.718 5.5 5.5.36.344.36-.344 5.5-5.5z"
        fill="#000"
      />
    </svg>
  );
};

export default React.memo(ChevronDown);
